export function range(start: number, stop: number, step: number): number[] {
    return Array.from({ length: (stop - start + step) / step }, (_, i) => start + (i * step))
}